import { createFileRoute } from "@tanstack/react-router";
import { SophiaKeywordsManager } from "@/components/admin/SophiaKeywordsManager";

export const Route = createFileRoute("/admin/ai/sophia")({
  component: SophiaKeywordsManager,
});
